import { createNav, bindNav } from "./components/Nav.js";
import { createFooter } from "./sections/Footer.js";
import { createContactSection } from "./sections/Contact.js";
import { createAboutHeroSection } from "./sections/about/AboutHero.js";
import { createAboutStorySection } from "./sections/about/AboutStory.js";
import { createAboutMissionSection } from "./sections/about/AboutMission.js";
import { createAboutValuesSection } from "./sections/about/AboutValues.js";
import { createAboutTimelineSection } from "./sections/about/AboutTimeline.js";
import { createAboutCtaSection } from "./sections/about/AboutCta.js";
import { getAboutPage, aboutRoute } from "../config/aboutContent.js";

export function mountAboutPage(root) {
  const pageContent = getAboutPage();

  const canvasLayer = document.createElement("div");
  canvasLayer.className = "canvas-layer";
  canvasLayer.innerHTML = `<canvas id="canvas" aria-hidden="true"></canvas>`;

  const contentLayer = document.createElement("div");
  contentLayer.className = "content-layer content-layer--about";

  const nav = createNav();

  contentLayer.append(
    nav,
    createAboutHeroSection(),
    createAboutStorySection(),
    createAboutMissionSection(),
    createAboutValuesSection(),
    createAboutTimelineSection(),
    createAboutCtaSection(),
    createContactSection(),
    createFooter()
  );

  root.append(canvasLayer, contentLayer);

  const updateNavActive = bindNav(nav, {
    page: "about",
    sectionMap: {
      hero: aboutRoute("hero"),
      story: aboutRoute("story"),
      mission: aboutRoute("mission"),
      values: aboutRoute("values"),
      path: aboutRoute("path"),
      next: aboutRoute("next"),
      contact: aboutRoute("contact"),
    },
  });

  return {
    canvas: canvasLayer.querySelector("#canvas"),
    updateNavActive,
    documentTitle: pageContent.documentTitle,
    sections: {
      hero: contentLayer.querySelector("#hero"),
      story: contentLayer.querySelector("#story"),
      mission: contentLayer.querySelector("#mission"),
      values: contentLayer.querySelector("#values"),
      path: contentLayer.querySelector("#path"),
      next: contentLayer.querySelector("#next"),
      contact: contentLayer.querySelector("#contact"),
    },
  };
}
